<template>
  <app-layout :subtitle="$t('downloadFiles.subtitle')">
    <template>
      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-3">
          <div v-if="packageLoaded">
            <p
              style="font-weight: bold;"
              v-if="!isMailbox">
                {{ $t('downloadFiles.sender.part1') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ sender }}</span> {{ $t('downloadFiles.sender.part2') }}
            </p>
            <p
              style="font-weight: bold;"
              v-else> <!-- isMailbox -->
                {{ $t('downloadFiles.recipient.part1') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ sender }}</span>
            </p>
          </div>
          <!-- TODO translations below -->
          <div v-else>
            <p
              style="font-weight: bold;"
              v-if="packageError === 'unauthorized'">
              Authorization required.
            </p>
            <p
              style="font-weight: bold;"
              v-else-if="packageError === 'invalid'">
              There are no files here.
            </p>
            <p
              style="font-weight: bold;"
              v-else-if="packageError === 'expired'">
              These files have expired.
            </p>
            <p
              style="font-weight: bold;"
              v-else-if="(packageError === undefined) || (packageError === 'passwordrequired')">
              Loading files ...
            </p>
            <p
              style="font-weight: bold;"
              v-else>
              Something went wrong. Try again later.
            </p>
          </div>
        </div>
      </div>
      <step-card :custom-style="customStyle" v-if="packageLoaded">
        <div slot="form-main-content">
          <step-card-toolbar slot="toolbar" :has-border='true'>
            <img src="../../assets/icons/datoteka.svg" alt="" class="toolbar__img" slot="toolbar-image">

            <template slot="toolbar-text">
              <slot name="toolbar-text">
                <span class="toolbar__text" v-if="downloadServlet === 'Download'">{{ $t('downloadFiles.toolbarText') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ validDate }}</span></span>
                <span class="toolbar__text" v-else>{{ $t('downloadFiles.validText') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ validDate }}</span></span>
              </slot>
            </template>

          </step-card-toolbar>

          <div class="download-form__content">
            <div class="download-form__description" v-if="description">
              <p v-html="description"></p>
            </div>
            <ul class="download-form__list" v-if="files">
              <download-files-item v-for="(file, index) in files"
                  :file="file"
                  :url="$route.params.id"
                  @download-file="downloadOne"
                  :key="index"></download-files-item>
            </ul>
            <error-popup :message="$store.state.errors.fileItem" v-if="$store.state.errors.fileItem" />
          </div>
        </div>
      </step-card>

      <step-publish v-if="packageLoaded"
          :button-text="$t('downloadFiles.buttonText')"
          :class-object="{'card-white': true}"
          :is-button-disabled="false"
          :emit-custom="true"
          @publish-custom="downloadAll">
      </step-publish>

      <download-password-modal v-if="packageError === 'passwordrequired'" @submit-password="submitPassword" @close="close"></download-password-modal>

    </template>
  </app-layout>

</template>

<script>
import ContentCard from '../content/ContentCard'
import AppLayout from '../layout/AppLayout'
import StepCard from '../step/StepCard'
import StepPublish from '../step/StepPublish'
import StepCardToolbar from '../step/StepCardToolbar'
import DownloadFilesItem from './DownloadFilesItem'
import DownloadPasswordModal from './DownloadPasswordModal'
import ErrorPopup from '../ui/ErrorPopup'

import moment from 'moment'

export default {
  name: "DownloadFiles",
  components: {
    AppLayout,
    StepPublish,
    DownloadFilesItem,
    StepCardToolbar,
    StepCard,
    DownloadPasswordModal,
    ContentCard,
    ErrorPopup,
  },
  data() {
    return {
      packageLoaded: false,
      packageError: null,
      description: "",
      files: null,
      file: null,
      validDate: null,
      downloadServlet: null,
      sender: null,
      error: null,
      zipUrlBlob: null,
    }
  },
  methods: {
    getFilesList() {
      this.$http.get(this.getFilesUrl, {
        credentials: true
      }).then(response => {
        this.packageError = response.body.packageError;
        if(this.packageError !== undefined) {
          return
        }

        this.packageLoaded = true
        this.files = response.body.files
        this.file = response.body.file
        this.validDate = response.body.validTo
        this.downloadServlet = response.body.downloadServlet
        this.description = response.body.description
        this.sender = response.body.owner
        this.error = response.body.error
        this.zipUrlBlob = response.body.zipUrlBlob

        if (this.error === undefined && this.$route.query.error) {
          this.error = this.$route.query.error
        }

        if(this.error !== undefined) {      
          if(this.error === 'maxDl') {
            this.$store.setErrors({
              fileItem: this.$t('errors.downloadLimit')
            })
          } else {
            // TODO some other general error
            this.$store.setErrors({
              fileItem: this.$t('errors.invalidPackage')
            })
          }
          return
        }

        if (this.file !== undefined) {
          this.downloadOne(this.file)
        }
      }, response => {        
        packageError = 'invalid'
      })
    },
    close() {
    },
    submitPassword(value) {
        const data = "url=" + this.$route.params.id
        this.$http.post('/download/verify', data, {
          credentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-SOVD-Packet-Password": value
          }
        }).then(response => {
          if (response.body > 0) {
            const timeoutDate = new Date(response.body)
            // TODO translate
            const msg = "Prevečkrat ste vnesli napačno geslo. Ponovno lahko poskusite ob: " + moment(response.body).format('H:mm:ss')
            this.$store.setErrors({
              password: msg
            })
          } else if (response.body < 0) {
            this.$store.setErrors({
              password: this.$t('errors.wrongPassword')
            })
          } else {
            this.$store.resetError("password")
            this.$store.setPassword(value)
            this.close()
            this.getFilesList()
          }
        }, response => {
          // error
        })
    },
    downloadAll() {
      window.location = '/' + this.downloadServlet + '?b=' + this.zipUrlBlob
    },
    downloadOne(file) {
      window.location = '/' + this.downloadServlet + '?b=' + file.accessUrlBlob
    }
  },
  computed: {
    canUploadFiles() {
      return this.$store.state.files.length
    },
    customStyle() {
      return {
        'padding': '17px 0 0 14px'
      }
    },
    getFilesUrl() {
      if (this.$route.path.indexOf('/received/') !== -1) {
        return '/private/api/received/' + this.$route.params.id + "?b=" + this.$route.query.b
      } else {
        return '/public/api/download/' + this.$route.params.id + "?b=" + this.$route.query.b
      }
    }
  },
  mounted() {
    this.getFilesList()
  },
  destroyed() {
    this.$store.resetStore()
  }
}
</script>

<style lang="scss">
// @import "abstracts/variables_shared";

.download-form {
  &__list {
    list-style: none;
    min-height: 115px;
  }

  &__description {
    border-bottom: 1px solid #e7e7e7;
    padding: 9px 0;
    padding-right: 15px;
    font-weight: 600;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/download/DownloadFiles.vue